import { jsx, jsxs } from "react/jsx-runtime";
import { lazy, Suspense } from "react";
import { PageSection } from "./PageSection.js";
import resolveComponent, { resolveComponentFlags } from "../utils/resolve-component.js";
const ShowPropsBlock = lazy(async () => {
  const module = await import("../../components/ShowPropsBlock/ShowPropsBlock.js");
  return { default: module.ShowPropsBlock };
});
function BaseCmsContent({ ctx, data }) {
  const Component = resolveComponent(data.name, data.props, ctx);
  const pageContext = ctx.getPageContext();
  const flags = resolveComponentFlags(data.name, data.props, ctx);
  let items = {};
  if (flags?.isLayout) {
    items = flags?.layoutProperties?.reduce((prei, i) => {
      return {
        ...prei,
        [i]: /* @__PURE__ */ jsx(PageSection, { components: data.props[i], ctx })
      };
    }, {}) || {};
  }
  if (flags?.fieldsToParse?.length) {
    flags?.fieldsToParse?.forEach((i) => {
      const componentToParse = data.props[i];
      items[i] = /* @__PURE__ */ jsx(BaseCmsContent, { ctx, data: componentToParse });
    });
  }
  const showProps = !!("showProps" in (pageContext.searchParams ?? {}));
  if (showProps) {
    return /* @__PURE__ */ jsxs("div", { className: "border border-blue-500 p-4 relative [&:hover>_.hover-indicator]:block", children: [
      /* @__PURE__ */ jsx(Suspense, { fallback: null, children: /* @__PURE__ */ jsx(ShowPropsBlock, { componentName: data.name, data: data.props }) }),
      /* @__PURE__ */ jsx(Component, { componentName: data.name, ...data.props, ...items })
    ] });
  }
  return /* @__PURE__ */ jsx(Component, { componentName: data.name, ...data.props, ...items });
}
export {
  BaseCmsContent,
  BaseCmsContent as default
};
//# sourceMappingURL=BaseCmsContent.js.map
